
<si-newton-table [rows]="mlfbs" [loading]="(mlfbs) === null" [rowsPerPage]="100">
  <siNewtonTableColumn [widthFactor]="0.8" key="mlfb" name="MLFB"></siNewtonTableColumn>
  <siNewtonTableColumn [widthFactor]="0.8" key="contract_name" name="Contract"></siNewtonTableColumn>
  <siNewtonTableColumn [widthFactor]="0.8" key="quantity" name="Quantity"></siNewtonTableColumn>
</si-newton-table>
